/*
 * @Author: etong
 * @Date: 2021-01-27 13:51:41
 * @LastEditTime: 2023-02-09 09:57:06
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\store\getters.js
 * @Think first, Program later
 */
import activityDetailGetters from './getters/activitySetpriceManagement/activityDetail'
import financReportFormsTemplate from './getters/financReportFormsTemplate/index'
import common from './getters/common/index'
import vmRouteQuene from './getters/vmRouteQuene/index'

const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  message_num: state => state.app.message_num,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  status: state => state.user.status,
  roles: state => state.user.roles,
  setting: state => state.user.setting,
  userinfo: state => state.user.userInfo,
  permission_routers: state => state.permission.routers,
  addRouters: state => state.permission.addRouters,
  ...vmRouteQuene,
  ...activityDetailGetters,
  ...common,
  ...financReportFormsTemplate
}
export default getters
